export class UserDetails {
  id: string
  canEdit: boolean
  email: string
  firstName: string
  lastName: string
  receivesEmailNotifications: boolean
  roleId: string

  originalReceivesEmailNotifications: boolean
  originalRoleId: string

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(json: any) {
    this.id = json.id
    this.canEdit = json.canEdit
    this.email = json.email
    this.firstName = json.firstName
    this.lastName = json.lastName
    this.receivesEmailNotifications = json.receivesEmailNotifications
    this.roleId = json.roleId

    this.originalReceivesEmailNotifications = this.receivesEmailNotifications
    this.originalRoleId = this.roleId
  }

  get changed(): boolean {
    return this.originalReceivesEmailNotifications !== this.receivesEmailNotifications || this.originalRoleId !== this.roleId
  }
}